import { useToken } from '@ori/auth';
import { lazy } from 'react';

const TopArea = lazy(async () =>
  import('./TopArea').then((module) => ({ default: module.TopArea })),
);

// TODO -- Improve this after refactoring NavigationContext (make sure everything is loaded before TopNav gets rendered)
export const LazyTopArea = () => {
  const { formattedToken } = useToken();

  return formattedToken ? <TopArea /> : null;
};
